import React from "react";
import Form from "./Form";
import { FormattedMessage, useIntl } from "react-intl";
import { APP_VERSION } from "../../constants";
import AuthLayout from "../../layouts/AuthLayout";

const Login = () => {
  const intl = useIntl();
  
  return (
    <>
    <AuthLayout
    title={intl.formatMessage({ id: "forgot_password" , defaultMessage: "Forgot Password" })}
    description={intl.formatMessage({ id: "forgot_password_desc" , defaultMessage: "Enter your email below and we will send you a link to reset your password." })}
    >
            <Form />
    </AuthLayout>

                </>
  );
};

export default Login;
